import React from 'react'

import { StyleSheet, Text } from '@react-pdf/renderer'
import PropTypes from "prop-types"
import { reportErrorMessage } from 'utils/errorReporter'

const styles = StyleSheet.create({
  variableContent: {
    color: 'black',
  },
})

const ErrorDataText = ({ exception = null, contextName, text, extraData = {} }) => {
  const msg = text || 'Ocorreu um erro ao tratar os dados'
  
  if (exception) {
    reportError(exception, contextName, msg, extraData)
  }
  else {
    reportErrorMessage(msg, contextName, extraData)
  }
  
  return (
    <Text style={styles.variableContent}>
      {msg}
    </Text>
  )
}

ErrorDataText.propTypes = {
  text: PropTypes.string,
}

ErrorDataText.defaultProps = {
  text: null,
}
export default ErrorDataText
